<template>
  <div class="view">
    <save-page-header title="Category"></save-page-header>
    <el-form class="mt-30" :label-width="labelWidth + 'px'">
      <translatable-input
        :errors="errors"
        :source.sync="form.names"
        sourceKey="names"
        :isDisabled="true"
        :label-width="labelWidth"
      />
    </el-form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { apiError, labelWidth } from '@/mixins'
import TranslatableInput from '@/components/Form/TranslatableInput'
import { initMultilingual } from '@/services/helpers'
import SavePageHeader from '@/components/ui/SavePageHeader'

export default {
  components: {
    TranslatableInput,
    SavePageHeader,
  },
  mixins: [apiError('getCategoryError'), labelWidth],
  data: () => ({
    form: {
      names: initMultilingual(),
    },
  }),
  computed: {
    ...mapState('category', ['category', 'getCategoryError']),
    isFetch() {
      return this.$route.params.id !== undefined
    },
  },
  async mounted() {
    if (this.isFetch) {
      await this.getCategory({
        routeParameters: {
          id: this.$route.params.id,
        },
      })
      this.form = {
        ...this.category.data,
        names: initMultilingual(this.category.data.names),
      }
    }
  },
  methods: {
    ...mapActions('category', ['getCategory']),
  },
}
</script>
